'use client'
import { ChangeEventHandler, InputHTMLAttributes } from 'react'
import styles from './Checkbox.module.scss'

export default function Checkbox({
  className = '',
  onChange,
  value,
  checked,
  defaultChecked,
  ...checkboxProps
}: {
  className?: string
  onChange: ChangeEventHandler<HTMLInputElement>
  value?: InputHTMLAttributes<HTMLInputElement>['value']
  id?: string
  name?: string
  checked?: boolean
  defaultChecked?: boolean
}) {
  return (
    <span className={`${styles.checkbox} ${className}`}>
      <input
        type="checkbox"
        onChange={onChange}
        value={value}
        checked={checked}
        defaultChecked={defaultChecked}
        {...checkboxProps}
      />

      <span className="checkmark" />
    </span>
  )
}
